import Vue from 'vue'
import VueRouter from 'vue-router'
import {
    getToken,
    saveToken
} from "@/utils/auth";
import {
    Toast
} from "vant";

Vue.use(VueRouter)
import nativeApi from '@/utils/native-bridge'

const whiteList = ['public', 'home', 'app', 'demo', 'ZhiNanGjj']


const routes = [{
    path: '/notify',
    name: 'notify',
    component: () => import('../views/Notify.vue')
}, {
    path: '/public',
    name: 'public',
    component: () => import('../views/NewsPublic.vue')
}, {
    path: '/renwei',
    name: 'renwei',
    component: () => import('../views/RenWei.vue')
}, {
    path: '/zhinan-gjj',
    name: 'ZhiNanGjj',
    component: () => import('../views/ZhiNanGjj.vue')
}, {
    path: '/news',
    name: 'news',
    component: () => import('../views/News.vue')
}, {
    path: '/service',
    name: 'service',
    component: () => import('../views/Service.vue')
}, {
    path: '/service-list',
    name: 'serviceList',
    component: () => import('../views/ServiceList.vue')
}, {
    path: '/user-info',
    title: '入职信息',
    name: 'userinfo',
    component: () => import('../views/UserInfo.vue')
}, {
    path: '/user-edit',
    title: '信息维护',
    name: 'UserInfoEdit',
    component: () => import('../views/UserInfoEdit.vue')
}, {
    path: '/zhi-nan',
    name: 'zhinan',
    component: () => import('../views/ZhiNan.vue')
}, {
    path: '/gongzi',
    name: 'gongzi',
    component: () => import('../views/Gongzi.vue')
}, {
    path: '/apply-list',
    name: 'applyList',
    component: () => import('../views/ApplyList.vue')
}, {
    path: '/apply-detail',
    name: 'applyDetail',
    component: () => import('../views/ApplyDetail.vue')
}, {
    path: '/hetong',
    name: 'hetong',
    component: () => import('../views/HeTong.vue')
}, {
    path: '/news-list',
    name: 'newslist',
    component: () => import('../views/NewsList.vue')
}, {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
},
    {
        path: '/app',
        name: 'app',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/reservation',
        name: 'reservation',
        component: () => import('../views/reservation.vue')
    },
    {
        path: '/bind-personnel',
        name: 'BindPersonnel',
        component: () => import('../views/bind-personnel.vue')
    },
    {
        path: '/reservation-preview',
        name: 'reservation-preview',
        component: () => import('../views/reservation-preview.vue')
    },
    {
        path: '/reservation-main',
        name: 'reservationMain',
        component: () => import('../views/reservation-main.vue')
    },
    {
        path: '/reservation-my',
        name: 'reservation-my',
        component: () => import('../views/reservation-my.vue')
    },
    {
        path: '/file-demo',
        name: 'fieldemo',
        component: () => import('../views/FileDemo.vue')
    },
    {
        path: '/gongzi-demo',
        name: 'gongzidemo',
        component: () => import('../views/GongziDemo.vue')
    },
    {
        path: '/esign-center',
        name: 'esign-center',
        component: () => import('../views/esign-center.vue')
    },
    {
        path: '/esign-center-add',
        name: 'EsignCenterAdd',
        component: () => import('../views/esign-center-add.vue')
    },
    {
        path: '/esign-center-delete',
        name: 'EsignCenterDelete',
        component: () => import('../views/esign-center-delete.vue')
    },
    {
        path: '/esign-center-resign',
        name: 'EsignCenterResign',
        component: () => import('../views/esign-center-resign.vue')
    },
    {
        path: '/cert-center',
        name: 'cert-center',
        component: () => import('../views/cert-center.vue')
    },
    {
        path: '/cert-center-work',
        name: 'CertCenterWork',
        component: () => import('../views/cert-center-work.vue')
    },
    {
        path: '/cert-center-work-create',
        name: 'CertCenterWorkCreate',
        component: () => import('../views/cert-center-work-create.vue')
    },
    {
        path: '/cert-center-income',
        name: 'cert-center-income',
        component: () => import('../views/cert-center-work.vue')
    },
    {
        path: '/cert-center-leave',
        name: 'cert-center-leave',
        component: () => import('../views/cert-center-work.vue')
    },
    {
        path: '/user-info-add',
        name: 'UserInfoAdd',
        component: () => import('../views/UserInfoAdd.vue')
    },
    {
        path: '/user-info-resign',
        name: 'UserInfoResign',
        component: () => import('../views/UserInfoResign.vue')
    },
    {
        path: '/user-info-delete',
        name: 'UserInfoDelete',
        component: () => import('../views/UserInfoDelete.vue')
    },
    {
        path: '*',
        name: 'home',
        component: () => import('../views/Home.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})


router.beforeEach((to, from, next) => {
    console.info(`to == > ${to.name}`)
    const toast = Toast.loading({
        duration: 0
    });
    if (to.meta.title) {
        document.title = to.meta.title
    }
    const token = process.env.VUE_APP_HOOK_SID;
    const toName = to.name
    //getToken();
    console.info('=======>' + token)
    if (whiteList.some((name) => {
        return name === toName
    })) {
        console.info('in whiteList')
        next()
        toast.clear()
        return
    }

    if (!token || token === 'undefined') {
        nativeApi.getUserInfo({
            success: (data) => {
                console.info('get ===>' + data.userToken)
                saveToken(data.userToken)
                next()
                toast.clear()
            },
            cancel: () => {
                toast.clear()
                Toast('未登录');
            },
            error: (rep) => {
                toast.clear()
                Toast('未登录:' + rep.msg);
            }
        })
    } else {
        next()
        toast.clear()
    }
})

export default router
